import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, FormHelperText, Grid, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { makeStyles } from "../tss";
import Mainlogo from "../images/Logo_Color1.png";
import FormControl from "@mui/material/FormControl";
import OutlinedInput from "@mui/material/OutlinedInput";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { FORGET_PASSWORD } from "../common/url";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { SIGNIN_ROUTE, SIGNUP_ROUTE } from "../constants/RoutePaths";
import { authHeader } from "../common/mainfunction";
import API from "../constants/API";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { CustomMessage } from "../common/helperfunction";
import ForgetPasswordResponse from "./Modal/ForgotPasswordResponse";

const useStyles = makeStyles((_theme) => ({
  loginbox: {
    backgroundColor: "var(--bg-surface)",
    padding: "30px 40px",
    borderRadius: "16px",
    textAlign: "left",
    boxShadow: "3px 3px 20px #00000017",
    maxWidth: "440px",
    margin: "auto",
  },
  otpbtn: {
    margin: "24px 0px 0px 0px !important",
    backgroundColor: "var(--color-brand) !important",
    boxShadow: "none !important",
    textTransform: "none !important",
    // "&:hover": {
    //   color: "var(--color-brand) !important",
    //   border: "1px solid var(--color-brand) !important",
    //   backgroundColor: "transparent !important",
    //   boxShadow: "none !important",
    // },
  },
}));

const _Input = styled("input")({
  display: "none",
});

const _CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "green",
    borderRadius: "8px",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
    borderRadius: "8px",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#F0F1F5",
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      borderColor: "var(--text-primary)",
      borderRadius: "8px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--text-primary)",
      borderRadius: "8px",
    },
  },
});

function Forgotpassword() {
  const { t } = useTranslation("auth");
  const styleclasses = useStyles();
  const history = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setloading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const validationSchema = Yup.object().shape({
    email: Yup.string().email(t("validation.invalidEmail")).required(t("validation.required")),
  });

  const { handleSubmit, handleChange, values, handleBlur, errors, touched } = useFormik<
    Record<string, any>
  >({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit(values) {
      ForgetPassword(values);
    },
  });

  const ForgetPassword = async (values: any) => {
    setloading(true);
    const config = {
      method: "PUT",
      url: FORGET_PASSWORD,
      headers: authHeader(),
      // data: values,
      data: values,
    };
    try {
      const response = await API(config);
      //const { status } = response.data;
      const { status } = response.data;

      if (status === "Success") {
        localStorage.setItem("EMAIL", values.email);
        setModalContent(t("forgotPassword.newPasswordSent"));
        setModalOpen(true);
        // CustomMessage(
        //   "Your new password has successfully been sent to your registered email address.",
        //   "success",
        //   enqueueSnackbar
        // ); //call toster
        // history(SIGNIN_ROUTE);
      } else {
        CustomMessage(t("notifications:auth.invalidData"), "error", enqueueSnackbar); //call toster
      }
    } catch (error) {
      const err = error as { response?: { data?: { message?: string } }; message?: string };
      // let errorObj = Object.assign({}, error);
      // let { data } = errorObj.response;
      // let { message } = data;
      // Swal.fire(message);
      if (err.response) {
        const { data } = err.response;
        const parsedErr = data;

        CustomMessage(parsedErr?.message, "error", enqueueSnackbar); //call tost
      }
    } finally {
      setloading(false);
    }
  };

  const _gotTosigin = () => {
    history(SIGNIN_ROUTE);
  };

  const goTosiginup = () => {
    history(SIGNUP_ROUTE);
  };

  const closeToggle = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Box component={"form"} onSubmit={handleSubmit} sx={{ width: "100%", height: "100vh" }}>
        <Grid
          sx={{ margin: "auto" }}
          size={{
            xs: 12,
            md: 4,
          }}
        >
          <Box>
            <img
              src={Mainlogo}
              style={{ marginTop: "30px", marginBottom: "20px" }}
              alt={t("common:alt.ezCloudLogo")}
            />
          </Box>
          <Box className={styleclasses.loginbox}>
            <Typography sx={{ mt: 1, mb: 3, fontWeight: "600" }} align="center" variant="h5">
              {t("forgotPassword.title")}
            </Typography>
            <Typography align="center" paragraph color="gray">
              {t("forgotPassword.description")}
            </Typography>
            <Typography gutterBottom sx={{ fontWeight: 600, color: "#4E4B66" }}>
              {t("forgotPassword.emailLabel")}
            </Typography>
            <FormControl sx={{ width: "100%" }} variant="outlined">
              <OutlinedInput
                type={"text"}
                error={!!errors.email && !!touched.email}
                onBlur={handleBlur}
                value={values.email}
                onChange={handleChange}
                placeholder={t("forgotPassword.emailPlaceholder")}
                name="email"
              />
              <FormHelperText error={true}>
                {errors.email && touched.email ? String(errors.email) : ""}
              </FormHelperText>
            </FormControl>
            {/* <Box sx={{ textAlign: "right" }}>
                <Link
                  sx={{
                    mt: 2,
                    mb: 3,
                    fontWeight: "600",
                    textDecoration: "none",
                    color: "var(--color-blue)",
                  }}
                  component="button"
                  variant="body2"
                  onClick={gotTosigin}
                >
                  Sign in
                </Link>
              </Box> */}
            <Box sx={{ textAlign: "center" }}>
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                className={styleclasses.otpbtn}
              >
                {t("forgotPassword.resetButton")}
              </Button>
            </Box>
          </Box>
          <Typography sx={{ mt: 2 }}>
            {t("forgotPassword.dontHaveAccount")}
            <Link
              sx={{ ml: 1, fontWeight: "600", textDecoration: "none", color: "var(--color-info)" }}
              component="button"
              variant="body2"
              onClick={goTosiginup}
            >
              {t("forgotPassword.signUpLink")}
            </Link>
          </Typography>
        </Grid>
      </Box>
      <ForgetPasswordResponse
        toggleOn={modalOpen}
        closeToggle={closeToggle}
        content={modalContent}
      />
    </>
  );
}

export default Forgotpassword;
